import type { QueryFunctionContext } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { GoogleAdvertiserDTO } from './types';
import type { AdsLibraryApiPathParams } from './parseAdsLibraryApiPath';
import { parseAdsLibraryApiPath } from './parseAdsLibraryApiPath';

export const getGoogleAdAdvertisers = async ({
  signal,
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<GoogleAdvertiserDTO[]> => {
  const res = await apiClient.get<{ data: GoogleAdvertiserDTO[] }>(queryKey[1], {
    signal,
  });
  return res.data.data;
};

export const getGoogleAdAdvertisersOptions = (params: AdsLibraryApiPathParams = {}) =>
  queryOptions({
    staleTime: 60 * 60 * 1000,
    queryFn: getGoogleAdAdvertisers,
    queryKey: ['google-ad-advertisers', parseAdsLibraryApiPath('ad_advertisers', params)] as const,
  });
